import { library } from "@fortawesome/fontawesome-svg-core";

/* Regular */
import { faCheckCircle as farCheckCircle } from "@fortawesome/pro-regular-svg-icons/faCheckCircle";
import { faInfoCircle as farInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faTimesCircle as farTimesCircle } from "@fortawesome/pro-regular-svg-icons/faTimesCircle";

/* Light */
import { faAnalytics as falAnalytics } from "@fortawesome/pro-light-svg-icons/faAnalytics";
import { faCheck as falCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faChevronDown as falChevronDown } from "@fortawesome/pro-light-svg-icons/faChevronDown";
import { faChevronRight as falChevronRight } from "@fortawesome/pro-light-svg-icons/faChevronRight";
import { faChevronUp as falChevronUp } from "@fortawesome/pro-light-svg-icons/faChevronUp";
import { faClock as falClock } from "@fortawesome/pro-light-svg-icons/faClock";
import { faCog as falCog } from "@fortawesome/pro-light-svg-icons/faCog";
import { faCogs as falCogs } from "@fortawesome/pro-light-svg-icons/faCogs";
import { faCube as falCube } from "@fortawesome/pro-light-svg-icons/faCube";
import { faEdit as falEdit } from "@fortawesome/pro-light-svg-icons/faEdit";
import { faEnvelope as falEnvelope } from "@fortawesome/pro-light-svg-icons/faEnvelope";
import { faExpand as falExpand } from "@fortawesome/pro-light-svg-icons/faExpand";
import { faExternalLink as falExternalLink } from "@fortawesome/pro-light-svg-icons/faExternalLink";
import { faEye as falEye } from "@fortawesome/pro-light-svg-icons/faEye";
import { faEyeSlash as falEyeSlash } from "@fortawesome/pro-light-svg-icons/faEyeSlash";
import { faFileChartLine as falFileChartLine } from "@fortawesome/pro-light-svg-icons/faFileChartLine";
import { faFlagAlt as falFlagAlt } from "@fortawesome/pro-light-svg-icons/faFlagAlt";
import { faFolders as falFolders } from "@fortawesome/pro-light-svg-icons/faFolders";
import { faGamepad as falGamepad } from "@fortawesome/pro-light-svg-icons/faGamepad";
import { faKey as falKey } from "@fortawesome/pro-light-svg-icons/faKey";
import { faLink as falLink } from "@fortawesome/pro-light-svg-icons/faLink";
import { faLock as falLock } from "@fortawesome/pro-light-svg-icons/faLock";
import { faLockAlt as falLockAlt } from "@fortawesome/pro-light-svg-icons/faLockAlt";
import { faLockOpenAlt as falLockOpenAlt } from "@fortawesome/pro-light-svg-icons/faLockOpenAlt";
import { faLongArrowRight as falLongArrowRight } from "@fortawesome/pro-light-svg-icons/faLongArrowRight";
import { faMobile as falMobile } from "@fortawesome/pro-light-svg-icons/faMobile";
import { faPhoneVolume as falPhoneVolume } from "@fortawesome/pro-light-svg-icons/faPhoneVolume";
import { faPlus as falPlus } from "@fortawesome/pro-light-svg-icons/faPlus";
import { faPlusCircle as falPlusCircle } from "@fortawesome/pro-light-svg-icons/faPlusCircle";
import { faPrint as falPrint } from "@fortawesome/pro-light-svg-icons/faPrint";
import { faShip as falShip } from "@fortawesome/pro-light-svg-icons/faShip";
import { faSpinnerThird as falSpinnerThird } from "@fortawesome/pro-light-svg-icons/faSpinnerThird";
import { faStar as falStar } from "@fortawesome/pro-light-svg-icons/faStar";
import { faStepBackward as falStepBackward } from "@fortawesome/pro-light-svg-icons/faStepBackward";
import { faSyncAlt as falSyncAlt } from "@fortawesome/pro-light-svg-icons/faSyncAlt";
import { faTachometerFast as falTachometerFast } from "@fortawesome/pro-light-svg-icons/faTachometerFast";
import { faThumbtack as falThumbtack } from "@fortawesome/pro-light-svg-icons/faThumbtack";
import { faTimes as falTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faTrashAlt as falTrashAlt } from "@fortawesome/pro-light-svg-icons/faTrashAlt";
import { faUser as falUser } from "@fortawesome/pro-light-svg-icons/faUser";
import { faUserCog as falUserCog } from "@fortawesome/pro-light-svg-icons/faUserCog";
import { faUserEdit as falUserEdit } from "@fortawesome/pro-light-svg-icons/faUserEdit";
import { faUserFriends as falUserFriends } from "@fortawesome/pro-light-svg-icons/faUserFriends";
import { faUsersClass as falUsersClass } from "@fortawesome/pro-light-svg-icons/faUsersClass";
import { faUserPlus as falUserPlus } from "@fortawesome/pro-light-svg-icons/faUserPlus";
import { faUsers as falUsers } from "@fortawesome/pro-light-svg-icons/faUsers";
import { faUserTag as falUserTag } from "@fortawesome/pro-light-svg-icons/faUserTag";
import { faUserTimes as falUserTimes } from "@fortawesome/pro-light-svg-icons/faUserTimes";

/* Solid */
import { faExclamation as fasExclamation } from "@fortawesome/pro-solid-svg-icons/faExclamation";
import { faInfoCircle as fasInfoCircle } from "@fortawesome/pro-solid-svg-icons/faInfoCircle";

/* Placeholders */
import { faSquare as falSquare } from "@fortawesome/pro-light-svg-icons/faSquare";

library.add(
  ...[
    farCheckCircle,
    farInfoCircle,
    farTimesCircle,
    falAnalytics,
    falCheck,
    falChevronDown,
    falChevronRight,
    falChevronUp,
    falClock,
    falCog,
    falCogs,
    falCube,
    falEdit,
    falEnvelope,
    falExpand,
    falExternalLink,
    falEye,
    falEyeSlash,
    falFileChartLine,
    falFlagAlt,
    falFolders,
    falGamepad,
    falKey,
    falLink,
    falLock,
    falLockAlt,
    falLockOpenAlt,
    falLongArrowRight,
    falMobile,
    falPhoneVolume,
    falPlus,
    falPlusCircle,
    falPrint,
    falShip,
    falSpinnerThird,
    falSquare,
    falStar,
    falStepBackward,
    falSyncAlt,
    falTachometerFast,
    falThumbtack,
    falTimes,
    falTrashAlt,
    falUser,
    falUserCog,
    falUserEdit,
    falUserFriends,
    falUsersClass,
    falUserPlus,
    falUsers,
    falUserTag,
    falUserTimes,

    fasExclamation,
    fasInfoCircle
  ] as any
);
